
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'finance-refund-requested',
	title: 'FINANCE_REFUND_REQUESTED'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "api-reference/events/finance-refund-requested",
  "id": "api-reference/events/finance-refund-requested",
  "isDocsHomePage": false,
  "title": "FINANCE_REFUND_REQUESTED",
  "description": "Request payload",
  "source": "@site/docs/api-reference/events/finance-refund-requested.md",
  "sourceDirName": "api-reference/events",
  "slug": "/api-reference/events/finance-refund-requested",
  "permalink": "/docs/api-reference/events/finance-refund-requested",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "finance-refund-requested",
    "title": "FINANCE_REFUND_REQUESTED"
  },
  "sidebar": "docs",
  "previous": {
    "title": "FINANCE_REFUND_PAID",
    "permalink": "/docs/api-reference/events/finance-refund-paid"
  },
  "next": {
    "title": "GET_QUOTES",
    "permalink": "/docs/api-reference/events/get-quotes"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [{
  value: 'Request payload',
  id: 'request-payload',
  children: []
}];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3 {...{
      "id": "request-payload"
    }}>{`Request payload`}</h3>
    <p><strong parentName="p">{`POST:`}</strong>{` `}<inlineCode parentName="p">{`https://api.{ENV}.dais.com/ioi/v3/event/fire`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-curl"
      }}>{`curl --location --request POST 'https://api.{ENV}.dais.com/ioi/v3/event/fire' \\
--header 'Authorization: Basic <yourAuthHere>' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "type": "FINANCE_REFUND_REQUESTED",
    "clientId": "<clientId>",
    "quoteId": "<quoteId>",
    "policyId": "<policyId>",
    "policyNumber": "<policyNumber>"
}'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "type": "FINANCE_REFUND_REQUESTED",
    "clientId": "3781f5c0-fae6-4bab-8091-8d385fd2a8f5",
    "quoteId": "d0d0eadc-fb94-49e3-b03a-f3cb2bb6882c",
    "policyId": "fcbd4955-9f37-4c95-97d2-aa9144c9811a",
    "policyNumber": "123456789"
}
`}</code></pre>
    <p><strong parentName="p">{`Event payload fields:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`type`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Must be set to `}<inlineCode parentName="td">{`FINANCE_REFUND_REQUESTED`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`clientId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID for the client`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`quoteId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID for the quote`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`policyId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID for the policy`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`policyNumber`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Policy number`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
